/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  settings: {
    id: 'elasticSearch.settings',
    defaultMessage: 'Settings'
  },
  instance: {
    id: 'elasticSearch.instance',
    defaultMessage: 'Instance'
  },
  options: {
    id: 'elasticSearch.options',
    defaultMessage: 'Options'
  },
  delete: {
    id: 'elasticSearch.delete',
    defaultMessage: 'Delete'
  },
  cancel: {
    id: 'elasticSearch.cancel',
    defaultMessage: 'Cancel'
  },
  status: {
    id: 'elasticSearch.status',
    defaultMessage: 'Status'
  },
  defaultFilter: {
    id: 'customService.defaultFilter',
    defaultMessage: 'Default filter'
  },
  defaultFilterPlaceholder: {
    id: 'customService.defaultFilterPlaceholder',
    defaultMessage: 'Can be anything (plain text, JSON, etc)'
  },
  metadata: {
    id: 'customService.metadata',
    defaultMessage: 'Metadata'
  },
  invalidJsonObjectValue: {
    id: 'customService.invalidObjectValue',
    defaultMessage: 'Please provide a valid JSON object.'
  }
});
